// @ts-strict-ignore
import { ArticleVO } from '@article/model/vo/article.vo';
import { ArticleUtils } from '@article/util/article-utils';
import { ConnectionAreaVO } from '@shared/vo/meta-element.vo';
import { IArticlePrepareProcessor } from './i-article-prepare.processor';
import { DefaultSingleConnectionPrepareProcessor } from './default-single-connection-prepare.processor';
import { DefaultMultipleConnectionPrepareProcessor } from './default-multiple-connection-prepare.processor';
import { EndPlateArticlePrepareProcessor } from './end-plate-article-prepare.processor';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ArticlePrepareProcessorRegistry {

  private _defaultSinglePrepareProcessor: DefaultSingleConnectionPrepareProcessor;
  private _defaultMultiplePrepareProcessor: DefaultMultipleConnectionPrepareProcessor;
  private _endPlatePrepareProcessor: EndPlateArticlePrepareProcessor;
  private initialized = false;

  public initialize(defaultSinglePrepareProcessor: DefaultSingleConnectionPrepareProcessor,
                    defaultMultiplePrepareProcessor: DefaultMultipleConnectionPrepareProcessor,
                    endPlatePrepareProcessor: EndPlateArticlePrepareProcessor,) {
    this._defaultSinglePrepareProcessor = defaultSinglePrepareProcessor;
    this._defaultMultiplePrepareProcessor = defaultMultiplePrepareProcessor;
    this._endPlatePrepareProcessor = endPlatePrepareProcessor;
    this.initialized = true;
  }

  public get(article: ArticleVO, connectionSetId: string = null): IArticlePrepareProcessor {

    if(!this.initialized) {
      throw new Error('ArticlePrepareProcessorRegistry not initialized!');
    }

    if (ArticleUtils.isEndPlateArticle(article)) {
      this._endPlatePrepareProcessor.defaultProcessor = this.getDefaultProcessorByGivingAreas(article, connectionSetId);
      return this._endPlatePrepareProcessor;
    } else {
      return this.getDefaultProcessorByGivingAreas(article, connectionSetId);
    }
  }

  private getDefaultProcessorByGivingAreas(article: ArticleVO, connectionSetId: string): IArticlePrepareProcessor {
    const givingAreasToProcess: ConnectionAreaVO[] = ArticleUtils.getGivingConnectionsSetFromArticle(article, connectionSetId);
    if (givingAreasToProcess.length > 1) {
      return this._defaultMultiplePrepareProcessor;
    } else {
      return this._defaultSinglePrepareProcessor;
    }
  }
}
